import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/content";

interface VideoCardProps {
  video: VideoItem;
  onPlay: (video: VideoItem) => void;
}

export default function VideoCard({ video, onPlay }: VideoCardProps) {
  return (
    <div className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors h-full">
      <button
        type="button"
        onClick={() => onPlay(video)}
        aria-label={`播放 ${video.title}`}
        className="relative block w-full aspect-video overflow-hidden bg-background-100 cursor-pointer"
      >
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} 韩国女主播视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/25 group-hover:bg-foreground-950/40 transition-colors">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/95 text-accent-600 group-hover:scale-110 transition-transform">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-foreground-950/75 text-background-50">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs bg-accent-500 text-background-50">
          {video.type}
        </span>
      </button>

      <div className="flex flex-col flex-1 p-4">
        <button
          type="button"
          onClick={() => onPlay(video)}
          className="text-left text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors cursor-pointer"
        >
          {video.title}
        </button>
        <div className="flex items-center justify-between mt-auto pt-3 text-xs text-foreground-500">
          <Link to={`/detail/${video.streamerId}`} className="hover:text-accent-600 transition-colors">
            <i className="ri-user-star-line mr-0.5"></i>
            {video.streamerName}
          </Link>
          <span>
            <i className="ri-eye-line mr-0.5"></i>
            {video.views}
          </span>
        </div>
      </div>
    </div>
  );
}